import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SavedReportsBookmarks = ({ onClose, onLoadBookmark }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const bookmarks = [
    {
      id: 1,
      name: 'Análise Mensal Padrão',
      description: 'Resumo mensal com todos os gráficos e tabelas',
      reportType: 'Resumo Mensal',
      createdAt: '15/11/2025',
      lastUsed: '28/11/2025',
      useCount: 12,
      parameters: {
        period: 'current-month',
        includeCharts: true,
        includeTables: true
      }
    },
    {
      id: 2,
      name: 'Top 5 Clientes',
      description: 'Análise de lucratividade dos 5 principais clientes',
      reportType: 'Lucratividade por Cliente',
      createdAt: '10/11/2025',
      lastUsed: '27/11/2025',
      useCount: 8,
      parameters: {
        client: 'top-5',
        comparison: 'previous-period'
      }
    },
    {
      id: 3,
      name: 'Despesas Trimestre',
      description: 'Detalhamento completo de despesas do trimestre',
      reportType: 'Detalhamento de Despesas',
      createdAt: '05/11/2025',
      lastUsed: '25/11/2025',
      useCount: 6,
      parameters: {
        period: 'current-quarter',
        category: 'all'
      }
    },
    {
      id: 4,
      name: 'Comparativo Anual',
      description: 'Comparação ano a ano de todos os indicadores',
      reportType: 'Comparação Anual',
      createdAt: '01/11/2025',
      lastUsed: '20/11/2025',
      useCount: 4,
      parameters: {
        comparison: 'same-period-last-year',
        showTrends: true
      }
    },
    {
      id: 5,
      name: 'Fluxo de Caixa Semanal',
      description: 'Análise detalhada do fluxo de caixa semanal',
      reportType: 'Fluxo de Caixa',
      createdAt: '28/10/2025',
      lastUsed: '28/11/2025',
      useCount: 15,
      parameters: {
        period: 'custom',
        includeCharts: true
      }
    }
  ];

  const filteredBookmarks = bookmarks?.filter(bookmark =>
    bookmark?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    bookmark?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    bookmark?.reportType?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleDelete = (bookmarkId) => {
    if (window.confirm('Tem certeza que deseja excluir este favorito?')) {
      console.log('Deleting bookmark:', bookmarkId);
    }
  };

  const getReportTypeIcon = (reportType) => {
    const iconMap = {
      'Resumo Mensal': 'Calendar',
      'Lucratividade por Cliente': 'Users',
      'Detalhamento de Despesas': 'Receipt',
      'Comparação Anual': 'TrendingUp',
      'Fluxo de Caixa': 'DollarSign'
    };
    return iconMap?.[reportType] || 'FileText';
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[1030] flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="p-6 border-b border-border flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Relatórios Salvos</h2>
            <p className="text-sm text-muted-foreground mt-1">Acesse rapidamente suas configurações favoritas</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 border-b border-border">
          <Input
            type="search"
            placeholder="Buscar relatórios salvos..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
          />
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {filteredBookmarks?.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
                <Icon name="Search" size={40} className="text-muted-foreground" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">Nenhum resultado encontrado</h3>
              <p className="text-sm text-muted-foreground">
                Tente ajustar sua busca ou limpar os filtros
              </p>
            </div>
          ) : (
            <div className="space-y-4">
              {filteredBookmarks?.map((bookmark) => (
                <div
                  key={bookmark?.id}
                  className="bg-background border border-border rounded-lg p-6 hover:border-primary/50 transition-all group"
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-start gap-4 flex-1">
                      <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <Icon name={getReportTypeIcon(bookmark?.reportType)} size={24} className="text-primary" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">
                          {bookmark?.name}
                        </h3>
                        <p className="text-sm text-muted-foreground mb-2">{bookmark?.description}</p>
                        <div className="flex items-center gap-4 text-xs text-muted-foreground">
                          <span className="flex items-center gap-1">
                            <Icon name="FileText" size={12} />
                            {bookmark?.reportType}
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="Clock" size={12} />
                            Usado {bookmark?.useCount}x
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="Calendar" size={12} />
                            Último uso: {bookmark?.lastUsed}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => onLoadBookmark(bookmark)}
                        className="p-2 rounded-md hover:bg-primary/10 text-primary transition-colors"
                        title="Carregar configuração"
                      >
                        <Icon name="Play" size={18} />
                      </button>
                      <button
                        onClick={() => handleDelete(bookmark?.id)}
                        className="p-2 rounded-md hover:bg-error/10 text-error transition-colors"
                        title="Excluir"
                      >
                        <Icon name="Trash2" size={18} />
                      </button>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-border">
                    <div className="flex items-center justify-between text-xs text-muted-foreground">
                      <span>Criado em {bookmark?.createdAt}</span>
                      <button
                        onClick={() => onLoadBookmark(bookmark)}
                        className="flex items-center gap-1 text-primary hover:text-primary/80 transition-colors font-medium"
                      >
                        Usar esta configuração
                        <Icon name="ArrowRight" size={14} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="p-6 border-t border-border">
          <Button variant="outline" fullWidth onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SavedReportsBookmarks;